import Form from '../component/um/usergroup/Form'
import _ from 'lodash'

import useTranslate from '../i18n/useTranslate'
import useAddUsergroup, { FormType, UplodeFileDocType } from '../services/um/useAddUsergroup'
import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Dialog, { DialogType } from '../control/dialog/dialog'
import useCheckEmail from '../services/um/useCheckEmail'
import { Grid, makeStyles, Paper, Typography, Container } from '@material-ui/core'
import useAuthenStore from '../stores/authen/authenStore'
import { RoutePath } from '../router/routesConfig'
import usePosition from '../services/um/lookups/usePosition'
import { fixPosition } from '../constants/constants'
import useCheckPersonnel from '../services/um/useCheckPersonnel'
import { FormInitial } from '../services/um/useEditUsergroup'

type dataLookup = {
    id: number
    name_th: string
    name_en: string
}
const UsergroupAdd = () => {
    const translate = useTranslate()
    const classes = useStyles()
    const { postOfficer } = useAddUsergroup()
    const { postCheck } = useCheckEmail()
    const { postCheckPersonnel } = useCheckPersonnel()
    const authenStore = useAuthenStore()
    const history = useHistory()
    const { position } = usePosition()
    const [initialValues, setInitialValues] = useState<any>({
        cunetID: '1',
        irb: authenStore.profile.irb?.toString(),
        signatureTH: null,
        signatureEN: null,
    })

    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const [checkEmail, setCheckEmail] = useState<boolean | null>(null)
    const [initialUploadFile, setInitialUploadFile] = useState<any>()
    const dialogTwoRef = useRef<Record<string, Function>>()
    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }
    const lang = translate.languageStore.currentLanguage as 'th' | 'en'

    const validateEmail = (email: string) => {
        const re =
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(email)
    }

    const onChangeUsername = () => {
        setCheckEmail(null)
    }

    const onchangeRadioCUNET = (form: any) => {
        setCheckEmail(null)
        form.change('username', '')
    }

    const topicInitial = [
        {
            id: undefined,
            no: '',
            name_th: '',
            name_en: '',
        },
    ]

    const initialUpload = async (initDocument?: FormInitial['documentInfo']) => {
        let uploadFileInit = topicInitial?.map(() => {
            return {
                uploadFileObj: {
                    fileList: [],
                },
            }
        }) as Array<UplodeFileDocType>

        uploadFileInit?.forEach((itm: UplodeFileDocType) => {
            initDocument?.forEach((docInfo: any) => {
                itm.uploadFileObj?.fileList.push({
                    ...docInfo,
                    fileID: docInfo?.fileID,
                    fileToken: `${docInfo?.fileToken}`,
                    filename: `${docInfo?.filename}`,
                    replaceFileID: docInfo?.replaceFileID ?? null,
                    date: `${docInfo?.date}`,
                })
            })
        })
        setInitialUploadFile(uploadFileInit)
    }

    const initialValue = {
        cunetID: '1',
        irb: authenStore.profile.irb,
        signatureTH: null,
        signatureEN: null,
    }

    const checkUserName = async (username: string, cunetID?: string) => {
        const isCUNET = cunetID === '1' // radio is select cu-net
        if (username) {
            const result = await postCheck(username, 2)
            if (isCUNET) {
                //เป็น cunet และสามารถ ลงทะเบียนได้
                if (result.message === 'pass' && result.cunet === true) {
                    setCheckEmail(true)
                    return
                }
                //เป็น cunet แต่ไม่สามารถลงทะเบียนได้ เพราะซ้ำกับในระบบ
                if (result.message === 'duplicate' && result.cunet === true) {
                    setCheckEmail(false)
                    setConfigDialog({
                        title: translate.get('ALERT.TITLE.NOTIFICATION'),
                        content: translate.get('UM.USERGROUP-ADD.DIALOG.DUPLICATE_CUNET'),
                        type: 'alert-message',
                    })
                    return dialogTwoRef.current?.openDialog()
                }
                //ไม่เป็น cu-net
                setCheckEmail(false)
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get('UM.USERGROUP-ADD.DIALOG.NOT_CUNET'),
                    type: 'alert-message',
                })
                return dialogTwoRef.current?.openDialog()
            }

            if (result.message === 'pass') {
                //ภายนอก และเป็น email สามารถใช้งานได้
                if (validateEmail(username)) {
                    setCheckEmail(true)
                    return
                }
                //ภายนอก แต่ไม่เป็น email ไม่สามารถใช้งานได้
                setCheckEmail(false)
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get('UM.USERGROUP-ADD.DIALOG.EMAIL'),
                    type: 'alert-message',
                })
                return dialogTwoRef.current?.openDialog()
            }
            //username ซ้ำกับ user ที่มีในระบบ
            setCheckEmail(false)
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('UM.USERGROUP-ADD.DIALOG.DUPLICATE'),
                type: 'alert-message',
            })
            dialogTwoRef.current?.openDialog()
        }
    }

    const save = async (values: FormType) => {
        const cunet = values.cunetID === '1'
        const isPhD = values.isPhD || false
        const isPositionSpecified = values.positionID === '7'
        const isBothIrb = values.isBothIrb
        const format = {
            ...values,
            title: {
                id: values.titleID,
                name: {
                    th: values.titleOtherTH,
                    en: values.titleOtherEN,
                },
            },
            position: {
                id: isPositionSpecified ? null : values.positionID,
                name: {
                    th: values.positionOtherTH,
                    en: values.positionOtherEN,
                },
            },
            cunet,
            isPhD,
            signatureTH: values.signatureTH ?? [],
            signatureEN: values.signatureEN ?? [],
            isBothIrb,
            createdBy: authenStore.profile.userId,
            documentInfo: [...values.documentInfo[0].uploadFileObj.fileList],
        }
        const result = await postOfficer(
            _.omit(format, ['cunetID', 'positionOtherTH', 'positionOtherEN', 'titleOtherTH', 'titleOtherEN']),
        )
        if (result) {
            if (result.status === 1) {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
                    type: 'alert-message',
                    onAfterClose: onBack,
                })
                dialogTwoRef.current?.openDialog()
            } else if (result.status === -2) {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.WARNING'),
                    content: translate.get('ALERT.CONTENT.DUPLICATE_GROUP_USER'),
                    type: 'alert-message',
                })
            }
        } else {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.ERROR'),
                content: translate.get('ALERT.CONTENT.SAVE_NOT_SUCCESS'),
                type: 'alert-message',
            })
        }
    }

    const onSubmit = async (values: FormType) => {
        if (!checkEmail) {
            setConfigDialog({
                title: translate.get('UM.USERGROUP-ADD.RECHECK'),
                content: translate.get('UM.USERGROUP-ADD.RECHECK_EMAIL'),
                type: 'alert-message',
            })

            dialogTwoRef.current?.openDialog()
            return
        }
        setConfigDialog({
            title: translate.get('ALERT.TITLE.NOTIFICATION'),
            content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
            type: 'alert-confirm',
            onClickConfirm: () => save(values),
        })

        dialogTwoRef.current?.openDialog()
    }

    const onBack = () => {
        history.push(RoutePath.officer)
    }

    const onChangeMobilePhone = (val: string, fnCallback: (valBack: string) => void) => {
        if (val) {
            fnCallback(val.replace(/[^\d]/g, '').slice(0, 20))
        }
    }
    const handleCUData = async (personnelId: string, form: any) => {
        const result = await postCheckPersonnel(personnelId)

        const formValues = form.getState().values

        if (result.data) {
            createInitialValue(result.data[0], formValues)
        } else {
            setInitialValues({ ...initialValues })
        }
    }

    const createInitialValue = (data: any, formValues: any) => {
        const initialData = {
            ...initialValues,
            ...formValues,
            nameTH: `${data.NAME_TH ?? null} ${data.SURNAME_TH ?? null}`,
            nameEN: `${data.NAME_EN ?? null} ${data.SURNAME_EN ?? null}`,
            positionID: findPosition(data.ACAD_TITLE_1), //เขาจะส่งมาเป็นตัวย่อ ต้องเอาไป แมทเอาเอง
            isPhD: data.DOCTORAL_TITLE ? true : false,
            titleID: data.TITLE_ID ?? null,
            homeTelephone: data.OFFICE_PHONENUMBER ?? null,
        }
        setInitialValues(initialData)
    }

    const findPosition = (positionTitle: string) => {
        const optPosition = formatPosition()
        const findPosition = optPosition.find((element) => element.shortName === positionTitle)

        return findPosition?.id
    }

    const formatPosition = () => {
        let lookupPosition = position.map((item: dataLookup) => {
            return {
                id: item.id.toString(),
                name: lang === 'en' ? item.name_en : item.name_th,
                shortName: '',
            }
        })

        lookupPosition = [
            { id: '7', name: translate.get('UM.USERGROUP-ADD.NOT_SPECIFIED'), shortName: '' },
            ...lookupPosition,
            { id: '6', name: translate.get('UM.USERGROUP-ADD.OTHER'), shortName: '' },
        ]

        fixPosition.forEach((itm) => {
            lookupPosition.forEach((item: any) => {
                if (itm.id === item.id) {
                    item.shortName = itm.shortName
                }
            })
        })

        return lookupPosition
    }

    useEffect(() => {
        initialUpload()
    }, [])
    return (
        <Container maxWidth="lg">
            <Grid container justify="center" alignContent="center" className={classes.root}>
                <Grid item xs={12}>
                    <Typography variant="h5" style={{ fontWeight: 'bold' }}>
                        {translate.get('UM.USERGROUP-ADD.TITLE')}
                    </Typography>
                </Grid>
                <Paper className={classes.paper}>
                    <Form
                        onClickSubmit={onSubmit}
                        onChangeMobilePhone={onChangeMobilePhone}
                        onClickBackLink={onBack}
                        onCheck={checkUserName}
                        onInitialCUData={handleCUData}
                        isChecked={checkEmail}
                        onChangeUsername={onChangeUsername}
                        onchangeRadioCUNET={onchangeRadioCUNET}
                        initialValue={initialValues}
                        topicInitial={topicInitial}
                        initialUploadFile={initialUploadFile}
                        // initialValues={initialValues}
                    />
                </Paper>
            </Grid>
            <Dialog onRef={onRefDialogTwo} {...configDialog} />
        </Container>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        height: '100%',
        // backgroundColor: 'red',
    },
    container: {
        padding: '24px',
        borderRadius: '8px',
    },
    item: {
        position: 'absolute',
    },
    paper: {
        width: '100%',
        margin: '2rem 0px',
        [theme.breakpoints.down('sm')]: {
            backgroundColor: 'unset',
            boxShadow: 'unset',
            margin: '0px',
        },
    },
}))

export default UsergroupAdd
